import styled from 'styled-components';

export const ButtonStyled = styled.button<{
  variant: 'primary' | 'outlined';
  disabled: boolean;
}>`
  width: 100%;
  height: 48px;
  border-radius: 16px;
  border: none;
  outline: none;
  cursor: pointer;
  font-weight: 700;
  font-size: 16px;

  ${props =>
    props.variant === 'primary' &&
    `
      background-color: #AD9552;
      color: #0C0C0C;
      border: 1px solid #AD9552;

      &:hover,
      &:focus,
      &:active {
        outline: none;
        border: none;
        box-shadow: none;
      }
      
      ${
        props.disabled &&
        `
          background-color: #E6DEC9;
          color: #AD9552;
          border: 1px solid #F7F4EE;
      `
      }
  `}

  ${props =>
    props.variant === 'outlined' &&
    `
      background-color: transparent;
      border: 2px solid #AD9552;
      color: #AD9552;

      &:hover,
      &:focus,
      &:active {
        outline: none;
        border: 2px solid #AD9552;
        box-shadow: none;
      }
      
      ${
        props.disabled &&
        `
          color: #59523D;
          border: 2px solid #59523D;
      `
      }
  `}
`;
